import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { from, lastValueFrom, Observable } from 'rxjs';

/**
 * Add Okta Authorization token to every Http request
 */
@Injectable({
  providedIn: 'root'
})
export class OktaTokenInterceptor implements HttpInterceptor {
  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.handle(req, next));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private async handle(req: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    const isAuthenticated = await this.oktaAuth.isAuthenticated();

    if (isAuthenticated) {
      const token = this.oktaAuth.getAccessToken();

      if (token) {
        const modifiedReq = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${token}`)
        });

        return lastValueFrom(next.handle(modifiedReq));
      }
    }

    return lastValueFrom(next.handle(req));
  }
}
